import { render, staticRenderFns } from "./RelatorioInscricaoEventoForm.vue?vue&type=template&id=8bc3d9c8&scoped=true&"
import script from "./RelatorioInscricaoEventoForm.vue?vue&type=script&lang=js&"
export * from "./RelatorioInscricaoEventoForm.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioInscricaoEventoForm.vue?vue&type=style&index=0&id=8bc3d9c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc3d9c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRadio,VRadioGroup,VRow,VSpacer,VTextField})
